// @flow

import React from 'react'
import styled from 'styled-components'
import { Visibility } from 'semantic-ui-react'
import { spacing } from 'frontend_core/dist/styles/variables'
import MainContents from 'components/templates/MainContents'
import ReservationListSection from 'components/organisms/ReservationListSection'
import Loading from 'components/atoms/Loading'
import { type ReservationType } from 'types/reservation'

const LoadingContainer = styled.div`
  padding: ${spacing.medium}px 0;
  text-align: center;
`

export type PropTypes = {
  reservationList: Array<ReservationType>,
  isLoading: boolean,
  onReachedBottom: Function,
}

export default class ReservationListPage extends React.Component<
  PropTypes,
  *,
  *,
> {
  render() {
    const { isLoading, reservationList, onReachedBottom } = this.props
    return (
      <MainContents>
        <ReservationListSection
          reservationList={reservationList}
          isLoading={isLoading}
        />
        <Visibility onBottomVisible={onReachedBottom} continuous />
        {isLoading && (
          <LoadingContainer>
            <Loading />
          </LoadingContainer>
        )}
      </MainContents>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/ReservationListPage/index.jsx